import Table from "@/components/AdvanceTable"
import {columns,getSearchParm} from "./data.js"
import {getList,addCLzhangdan,updateCLzhangdan,deleteCLzhangdan} from "@/api/cailiaodan.js"
import moment from "moment"
import {curdfn,tabledatatransform,cailiaoitem} from './fn'
import {formdatafn,excelheader} from './formdatafn'
import downloadexcel from "vue-json-excel";
moment.locale("zh-cn")

let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)
let dd1 = localStorage.getItem("date1"),dd2=localStorage.getItem("date2")

/**
 * 请求数据
 */
const request = {
	"get":getList,
	"add":addCLzhangdan,
	"update":updateCLzhangdan,
	"delet":deleteCLzhangdan,
	'handleData':(data)=>{
		data = new Proxy(data,{
			get(target,key){
				if(moment.isMoment(target[key])){
					return target[key].format("YYYY-MM-DD")
				}
				// if(key == "clinfo"){
				// 	return JSON.stringify(target[key])
				// }
				// if(key == "excels"){
				// 	return JSON.stringify(target[key])
				// }
				
				return target[key]
			}
			})
		return {...data}
	}
}
/**
 * 查询数据
 */
const searchData =  getSearchParm({
	name:"",
	idcard:"",
	banknum:"",
	workplace:"",
	cltype:"",
	starttime:dd1,
	endtime:dd2,
	cmpid:user.cmpid
})



export default {
	data(){
		return {
			excelheader,
			columns,
			workplaceArray:[],
			cltypeArray:[],
			request,
			searchData,
			formData:{excels:[]}
		}
	},
	components:{
		Table,
		downloadexcel
	},
	methods:{
		...curdfn,
		...tabledatatransform,
		...cailiaoitem,
		...formdatafn
	},
	mounted(){
		this.getworkpalceArrary()
		this.getciaoliaotypeArray()
	}
}
